// Logica de calculo pura y testeable. NO importa nada del DOM ni de Workers.
// Toda la aritmetica de precios/totales/saldos vive aca para poder testearla
// y para reusarla identica en el servidor (fuente de verdad) y en la UI.

import type { TipoMov } from "./types";

/** Subtotal de una linea: precio de lista x cantidad (en bultos). */
export function calcularSubtotal(precio: number, cantidad: number): number {
  return precio * cantidad;
}

/**
 * Total del pedido = suma de subtotales - descuento.
 * Equivale a K165 = K161 - K163 del Excel. No baja de 0.
 */
export function calcularTotalPedido(
  lineas: Array<{ subtotal: number }>,
  descuento = 0,
): number {
  const suma = lineas.reduce((acc, l) => acc + l.subtotal, 0);
  return Math.max(0, suma - descuento);
}

/** Redondeo comercial a pesos enteros (el dueno redondea para el cobro). */
export function redondearPeso(n: number): number {
  return Math.round(n);
}

export type Redondeo = "peso" | "ninguno";

/**
 * Aplica una suba: nuevo_bruto = viejo x (1 + %/100), con redondeo opcional.
 * Replica la mecanica de las columnas AUMENTO/REDONDEO del Excel.
 */
export function aplicarSuba(
  precioViejo: number,
  porcentaje: number,
  redondeo: Redondeo = "peso",
): number {
  const bruto = precioViejo * (1 + porcentaje / 100);
  return redondeo === "peso" ? redondearPeso(bruto) : bruto;
}

/**
 * Saldo de cuenta corriente: la COMPRA suma y todo lo demas resta
 * (DEVOLUCION, PAGO, FALTANTE y ANULACION). Nunca se persiste; siempre se
 * calcula, aca y en la vista v_saldos.
 */
export function calcularSaldo(
  movs: Array<{ tipo: TipoMov; monto: number }>,
): number {
  return movs.reduce((acc, m) => {
    if (m.tipo === "COMPRA") return acc + m.monto;
    return acc - m.monto; // DEVOLUCION y PAGO restan
  }, 0);
}

/**
 * Precio sin IVA (informativo): precio / (1 + tasa/100).
 * tasa en porcentaje (0 exento, 10 minima, 22 basica).
 */
export function sinIva(precio: number, tasa: number): number {
  return precio / (1 + tasa / 100);
}
